import { gql, Resolver } from '@apollo/client';

import { dashboardFields } from './constants';

export const GET_PRO_INGESTION = gql`
    query getProIngestion($statementId: String!) {
        proIngestion(statementId: $statementId) @client {
            filename
            statementId
            data {
                status_code
                dashboard {
                    ${dashboardFields}
                }
            }
        }
    }
`;

export const GET_PRO_INGESTIONS = gql`
    query getProIngestions {
        proIngestions @client {
            filename
            statementId
            data {
                status_code
                dashboard {
                    ${dashboardFields}
                }
            }
        }
    }
`;

interface ProIngestion {
    statementId: string;
}

interface Args {
    statementId: string;
}

export const proIngestion: Resolver = (
    obj: Record<string, unknown>,
    args: Args,
    { cache },
): Promise<PROIngestion | void> => {
    const { statementId } = args;

    const { proIngestions } = cache.readQuery({
        query: GET_PRO_INGESTIONS,
    });

    return proIngestions.find(
        (item: ProIngestion) => item.statementId === statementId,
    );
};
